<template>
  <div class="sidebar-navigation user-sidebar" ref="sidebarWrapper">
    <div class="sidebar-inner">
      <div class="service-item">
        <ul class="items-menu" role="menu">
          <li role="menuitem" v-for="(item, index) in $props.menuItems" :key="'item'+index">
            <a href="#"
               class="menu-item"
               @click.prevent="handleItemSelect(item)"
               :ref="'menuItem'+item.name"
               :class="{'active': isItemSelected(item)}">
              <div class="menu-item-inner">
                <span class="item-name">{{ item.title }}</span>
                <i v-if="item.submenu"
                   class="icon-sc-chevron-down chevron"
                   :class="{'active' : isItemSelected(item)}"></i>
              </div>
            </a>
            <transition name="expand" mode="out-in">
              <ul class="items-submenu"
                  role="menu"
                  :style="submenuHeightStyle(item.submenu.length)"
                  v-if="item.submenu && item.submenu.length && isItemSelected(item)">
                <li v-for="(subItem, idx) in item.submenu"
                    :key="'sub'+idx">
                  <a href="#"
                     class="submenu-item"
                     :class="{ 'active' : subItem.name === selectedItem.name }"
                     @click.prevent="selectItem(subItem)">
                    {{ subItem.title }}
                  </a>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-account-sidebar',
  props: {
    menuItems: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data () {
    return {
      selectedItem: ''
    }
  },
  methods: {
    handleItemSelect (item) {
      if (item.submenu && item.submenu.length) {
        this.selectItem(item.submenu[0])
      } else {
        this.selectItem(item)
      }
    },
    isItemSelected (item) {
      if (item.submenu && item.submenu.length) {
        return item.submenu.some(subItem => subItem.name === this.selectedItem.name)
      }
      return item.name === this.selectedItem.name
    },
    selectItem (item) {
      this.selectedItem = item
    },
    emitSidebarSelection () {
      this.$emit('selected', this.selectedItem)
    },
    submenuHeightStyle (itemsCount) {
      return {
        height: `${itemsCount * 37 + 10}px`,
        transition: 'height 0.3s'
      }
    }
  },
  watch: {
    selectedItem (newVal) {
      if (newVal) {
        this.emitSidebarSelection()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // set first menu item active
      this.selectedItem = this.$props.menuItems[0]
    })
  }
}
</script>

<style scoped lang="scss" src="./styles/sidebar.scss"></style>
<style scoped lang="scss">
.user-sidebar {

  @media (map_get($breakpoints, sm)) {
    max-height: 620px;
    height: auto;
    padding-top: 0;
    padding-bottom: 0;
  }

  .sidebar-inner {
    padding-right: 0;
  }

  ul.items-menu li {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid $grey;

    a.menu-item {
      padding-top: 0.8rem;
      padding-bottom: 0.8rem;
      margin-bottom: 0;
      font-size: 1.6rem;
      font-weight: 600;

      .menu-item-inner {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        i.chevron {
          font-size: 1.6rem;
          color: $primary;
          transform: rotate(0);
          will-change: transform;
          transition: transform 0.2s;

          &.active {
            transform: rotate(180deg);
          }
        }
      }
    }

    &:last-child {
      border-bottom: none;
    }

    ul.items-submenu {
      padding-left: 0;
      //padding-top: 1rem;
      will-change: height;

      li {
        border: none;
        padding: 0;

        &:first-child {
          margin-top: 1rem;
        }
      }
    }
  }
}
</style>
